module.exports = {"cookies":"Cookie","help":"Aiuto","privacy":"Privacy","signInButtonText":"Accedi con un Adobe ID","termsOfUse":"Condizioni d’uso","updated":"AGGIORNATO"}


//////////////////
// WEBPACK FOOTER
// ./src/components/ExpLogin/__localization__/ExpLogin/it_it.json
// module id = 947
// module chunks = 0